import { VideoJsPlayerOptions } from 'video.js';
export function getVideoJSConfig(
  overrideNativeHls: boolean
): VideoJsPlayerOptions {
  return {
    //sources: [{ src: 'https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8' }],
    fluid: true,
    fill: true,
    controls: true,
    techOrder: ['chromecast', 'html5'],
    html5: {
      vhs: {
        overrideNative: overrideNativeHls,
      },
      nativeAudioTracks: false,
      nativeVideoTracks: false,
      nativeTextTracks: false,
    },
    //textTrackSettings: false,
    liveui: true,
    responsive: true,
    controlBar: {
      children: [
        'playToggle',
        'volumePanel',
        'currentTimeDisplay',
        'timeDivider',
        'durationDisplay',
        'progressControl',
        'liveDisplay',
        'seekToLive',
        'customControlSpacer',
        'playbackRateMenuButton',
        /*"chaptersButton",
        "descriptionsButton",
        "subsCapsButton",
        "audioTrackButton",*/
        'fullscreenToggle',
      ].filter((x) => x !== undefined),
      volumePanel: {
        inline: false,
      },
    },
  };
}
